export default __webpack_public_path__ + "static/packing-ff8a508dbcdc9b549a16f893d7d4a6fa.jpg";